// CULTURA IMPERIUM — Theme JS v2

document.addEventListener('DOMContentLoaded', () => {

  // ---- MOBILE MENU ----
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileNav  = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav-close');
  if (menuToggle && mobileNav) menuToggle.addEventListener('click', () => mobileNav.classList.add('open'));
  if (mobileClose && mobileNav) mobileClose.addEventListener('click', () => mobileNav.classList.remove('open'));

  // ---- CART DRAWER ----
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartDrawer  = document.querySelector('.cart-drawer');
  const cartClose   = document.querySelector('.cart-drawer-close');
  const cartLinks   = document.querySelectorAll('.cart-link');

  function openCart() {
    if (cartOverlay) cartOverlay.classList.add('open');
    if (cartDrawer)  cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartOverlay) cartOverlay.classList.remove('open');
    if (cartDrawer)  cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }
  cartLinks.forEach(l => l.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ---- SLIDESHOW ----
  const slides = document.querySelectorAll('.slide');
  const dots   = document.querySelectorAll('.slide-dot');
  let current  = 0;
  let slideTimer;

  function goToSlide(n) {
    slides[current].classList.remove('active');
    dots[current]?.classList.remove('active');
    current = (n + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current]?.classList.add('active');
  }

  if (slides.length > 1) {
    slides[0].classList.add('active');
    dots[0]?.classList.add('active');
    slideTimer = setInterval(() => goToSlide(current + 1), 5000);

    document.querySelector('.slideshow-arrow.next')?.addEventListener('click', () => {
      clearInterval(slideTimer);
      goToSlide(current + 1);
      slideTimer = setInterval(() => goToSlide(current + 1), 5000);
    });
    document.querySelector('.slideshow-arrow.prev')?.addEventListener('click', () => {
      clearInterval(slideTimer);
      goToSlide(current - 1);
      slideTimer = setInterval(() => goToSlide(current + 1), 5000);
    });
    dots.forEach((dot, i) => dot.addEventListener('click', () => {
      clearInterval(slideTimer);
      goToSlide(i);
      slideTimer = setInterval(() => goToSlide(current + 1), 5000);
    }));
  } else if (slides.length === 1) {
    slides[0].classList.add('active');
  }

  // ---- TABBED COLLECTIONS ----
  const tabBtns   = document.querySelectorAll('.tab-btn');
  const tabPanels = document.querySelectorAll('.tab-panel');
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      tabBtns.forEach(b => b.classList.remove('active'));
      tabPanels.forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      document.querySelector(`.tab-panel[data-tab="${btn.dataset.tab}"]`)?.classList.add('active');
    });
  });
  tabBtns[0]?.classList.add('active');
  tabPanels[0]?.classList.add('active');

  // ---- COLLAPSIBLES ----
  document.querySelectorAll('.collapsible-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const body = trigger.nextElementSibling;
      trigger.classList.toggle('open');
      body.classList.toggle('open');
    });
  });

  // ---- SIZE SELECTOR ----
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.size-grid')?.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // ---- PRODUCT IMAGE GALLERY ----
  const thumbs = document.querySelectorAll('.product-thumbnail');
  const mainImg = document.querySelector('.product-main-img img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) mainImg.src = thumb.querySelector('img').src;
    });
  });

  // ---- STICKY ADD TO CART ----
  const stickyAtc = document.querySelector('.sticky-atc');
  const addToCartBtn = document.querySelector('.add-to-cart');
  if (stickyAtc && addToCartBtn) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          stickyAtc.classList.add('visible');
        } else {
          stickyAtc.classList.remove('visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(addToCartBtn);
  }

  // ---- COUNTDOWN TIMER ----
  const countdowns = document.querySelectorAll('.countdown');
  countdowns.forEach(cd => {
    const endTime = new Date(cd.dataset.end);
    function updateCountdown() {
      const now = new Date();
      const diff = endTime - now;
      if (diff <= 0) { cd.innerHTML = '<span style="font-family:var(--font-mono);font-size:11px;color:var(--black)">Drop Live Now</span>'; return; }
      const days  = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const mins  = Math.floor((diff % 3600000) / 60000);
      const secs  = Math.floor((diff % 60000) / 1000);
      cd.querySelector('[data-days]').textContent  = String(days).padStart(2,'0');
      cd.querySelector('[data-hours]').textContent = String(hours).padStart(2,'0');
      cd.querySelector('[data-mins]').textContent  = String(mins).padStart(2,'0');
      cd.querySelector('[data-secs]').textContent  = String(secs).padStart(2,'0');
    }
    updateCountdown();
    setInterval(updateCountdown, 1000);
  });

  // ---- SCROLL REVEAL ----
  const revealEls = document.querySelectorAll('.product-card, .collection-card, .lookbook-item, .story-block');
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });
  revealEls.forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    revealObserver.observe(el);
  });

});
